import React from 'react';

import FooterSection from './FooterSection';
import HeaderSection from './HeaderSection';

const Referral = ({ referralUrl, companyName }: { referralUrl: string; companyName?: string }) => {
  return (
    <>
      <HeaderSection referralUrl={referralUrl} />
      <FooterSection companyName={companyName} />
    </>
  );
};

export default Referral;
